import type { ZudokuConfig } from "zudoku";
import { GettingStartedPage } from "./src/GettingStartedPage.js";

const config: ZudokuConfig = {
  site: {
    title: "ALK API Documentation",
    logo: {
      src: { light: "/logo-light.svg", dark: "/logo-dark.svg" },
      alt: "ALK",
      width: "130px",
    },
  },
  metadata: {
    title: "%s | ALK",
    defaultTitle: "ALK API Documentation",
    favicon: "/logo-lonely.svg",
  },
  theme: {
    light: {
      background: "#ffffff",
      foreground: "#3B261C",
      card: "#ffffff",
      cardForeground: "#3B261C",
      popover: "#ffffff",
      popoverForeground: "#3B261C",
      primary: "#FFBD33",
      primaryForeground: "#3B261C",
      secondary: "#EE5F19",
      secondaryForeground: "#ffffff",
      muted: "#F7F2EE",
      mutedForeground: "#6B574E",
      accent: "#FFF2D1",
      accentForeground: "#3B261C",
      destructive: "#CC3322",
      destructiveForeground: "#ffffff",
      border: "rgba(59, 38, 28, 0.2)",
      input: "rgba(59, 38, 28, 0.2)",
      ring: "#FFBD33",
      radius: "0.75rem",
    },
    dark: {
      background: "#120B08",
      foreground: "#F7F2EE",
      card: "#120B08",
      cardForeground: "#F7F2EE",
      popover: "#120B08",
      popoverForeground: "#F7F2EE",
      primary: "#FFBD33",
      primaryForeground: "#120B08",
      secondary: "#EE5F19",
      secondaryForeground: "#120B08",
      muted: "rgba(247, 242, 238, 0.06)",
      mutedForeground: "rgba(247, 242, 238, 0.72)",
      accent: "rgba(255, 189, 51, 0.18)",
      accentForeground: "#F7F2EE",
      destructive: "#CC3322",
      destructiveForeground: "#F7F2EE",
      border: "rgba(247, 242, 238, 0.2)",
      input: "rgba(247, 242, 238, 0.2)",
      ring: "#FFBD33",
      radius: "0.75rem",
    },
    customCss: {
      "a:hover": { "text-decoration": "none" },
      "::selection": { background: "rgba(255, 189, 51, 0.35)" },
      "code, pre": { "font-variant-ligatures": "none" },
      ".prose p, .prose li": { "text-align": "justify", hyphens: "auto" },
    },
  },
  navigation: [
    {
      type: "category",
      label: "Documentation",
      icon: "library",
      items: [
        {
          type: "category",
          label: "ALK API",
          icon: "sparkles",
          items: [
            {
              type: "doc",
              file: "/introduction",
              icon: "file-text",
            },
            {
              type: "custom-page",
              label: "Getting Started",
              icon: "rocket",
              path: "/getting-started",
              element: <GettingStartedPage />,
            },
            {
              type: "doc",
              file: "/integration-journey",
              icon: "route",
            },
            {
              type: "doc",
              file: "/workflows",
              icon: "workflow",
            },
            {
              type: "doc",
              file: "/errors",
              icon: "triangle-alert",
            },
            {
              type: "doc",
              file: "/best-practices",
              icon: "shield-check",
            },
          ],
        },
        {
          type: "category",
          label: "API Reference",
          icon: "book-open",
          items: [
            {
              type: "link",
              icon: "code-xml",
              label: "API Explorer",
              to: "/api",
            },
          ],
        },
      ],
    },
    {
      type: "link",
      to: "/api",
      label: "API Reference",
      icon: "book-open",
    },
  ],
  redirects: [
    { from: "/", to: "/getting-started" },
    { from: "/web-request-errors", to: "/errors" },
  ],
  apis: [
    {
      type: "file",
      input: "./apis/openapi.yaml",
      path: "/api",
    },
  ],
};

export default config;
